module.exports = __webpack_public_path__ + "static/media/mic-speaking2.9958fdd4.svg";